// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__23GgP","loadingIcon":"style_loadingIcon__2ZxxP","text":"style_text__25HNo","loading":"style_loading__1QRP3"};